import { render, staticRenderFns } from "./V2BiddingTable.vue?vue&type=template&id=fd6be71a&scoped=true&"
import script from "./V2BiddingTable.vue?vue&type=script&lang=js&"
export * from "./V2BiddingTable.vue?vue&type=script&lang=js&"
import style0 from "./V2BiddingTable.vue?vue&type=style&index=0&id=fd6be71a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6be71a",
  null
  
)

export default component.exports